import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=2d5cf3cf&scoped=true&"
import script from "./testimonial.vue?vue&type=script&lang=js&"
export * from "./testimonial.vue?vue&type=script&lang=js&"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=2d5cf3cf&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cf3cf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default,Discover: require('/app/components/Discover.vue').default,TalkWithExpert: require('/app/components/TalkWithExpert.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
